import React from "react";
import { classNames } from "../../shared/utility";

function renderTextValue(value) {
  if (value == null || value === "") return "";
  if (Array.isArray(value)) {
    return value.map((item) => renderTextValue(item)).filter(Boolean).join(", ");
  }
  if (typeof value === "object") {
    return value.label ?? value.name ?? value.value ?? "";
  }
  return value;
}

export default function TextWithLabel(props) {
  const { label, labelClass, parentClass, text, textClass } = props;

  return (
    <div className={parentClass ? parentClass : null}>
      <div className="flex space-x-2 mb-1">
        <p
          className={classNames(
            labelClass ? labelClass : "font-12",
            "block font-medium text-gray-600",
          )}
        >
          {label}
        </p>
      </div>

      <div>
        <div className="flex space-x-2 mb-1">
          <p
            className={classNames(
              textClass ? textClass : "text-base",
              "block font-medium text-gray-900",
            )}
          >
            {renderTextValue(text)}
          </p>
        </div>
      </div>
    </div>
  );
}
